document.querySelectorAll('.product-bsb__form').forEach(function (form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var originalLabel = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('input[name="id"]').value, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        // The cart-drawer is rendered once at page load with whatever the
        // cart looked like *before* this add, so re-fetch its section HTML
        // fresh via Shopify's Section Rendering API before opening it —
        // otherwise it opens showing stale/empty contents.
        return Promise.all([
          fetch('/?section_id=cart-drawer').then(function (res) { return res.text(); }),
          fetch('/?section_id=cart-icon-bubble').then(function (res) { return res.text(); })
        ])
          .then(function (results) {
            var drawerDoc = new DOMParser().parseFromString(results[0], 'text/html');
            var freshDrawer = drawerDoc.querySelector('cart-drawer');
            var currentDrawer = document.querySelector('cart-drawer');
            if (freshDrawer && currentDrawer) currentDrawer.replaceWith(freshDrawer);

            // The section-rendering response wraps the icon+count markup in
            // #shopify-section-cart-icon-bubble, but the header's actual
            // cart link uses id="cart-icon-bubble" directly (no wrapper) —
            // swap that link's *contents* in, not try to match the wrapper.
            var bubbleDoc = new DOMParser().parseFromString(results[1], 'text/html');
            var freshBubbleWrapper = bubbleDoc.getElementById('shopify-section-cart-icon-bubble');
            var currentCartIcon = document.getElementById('cart-icon-bubble');
            if (freshBubbleWrapper && currentCartIcon) {
              currentCartIcon.innerHTML = freshBubbleWrapper.innerHTML;
            }
          })
          .catch(function () {})
          .then(function () {
            // Reuse the theme's own cart icon click handler (already wired
            // to open the cart drawer) instead of re-implementing it — this
            // keeps "add to cart" from navigating to /cart while staying on
            // whatever open/animation behavior the theme already ships.
            var cartIcon = document.querySelector('a[href="/cart"], a[href*="/cart"]');
            if (cartIcon) {
              cartIcon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            }
          });
      })
      .catch(function () {
        // Fall back to the original, non-AJAX behavior if anything goes
        // wrong, so this never leaves the button silently broken.
        form.submit();
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
      });
  });
});
